import { addWindowResizeEvent } from '@theme/utilities';

const selectors = {
	promotionBullsEyeContainer: '.promotion.promotion--layout-bulls-eye',
	promotionMain: '.promotion__main',
};

const promotionBullsEyeContainer = document.querySelectorAll(selectors.promotionBullsEyeContainer);

// Set custom properties about the dimensions of the content area to be used for the calculation of the center circle diameter.
const calculateContentArea = () => {
	promotionBullsEyeContainer.forEach((el) => {
		if (!(el instanceof HTMLElement)) return;
		const mainContainer = el.querySelector(selectors.promotionMain);
		if (mainContainer) {
			const mainContainerStyles = getComputedStyle(mainContainer);
			const width = mainContainer.clientWidth - parseFloat(mainContainerStyles.paddingLeft) - parseFloat(mainContainerStyles.paddingRight);
			const height = mainContainer.clientHeight - parseFloat(mainContainerStyles.paddingTop) - parseFloat(mainContainerStyles.paddingBottom);
			el.style.setProperty('--content-width', String(width));
			el.style.setProperty('--content-height', String(height));
		}
	});
};

if (promotionBullsEyeContainer.length) {
	calculateContentArea();
	addWindowResizeEvent(calculateContentArea);
}
